import { ArrowTopRightOnSquareIcon } from '@heroicons/react/20/solid'
import Tooltip from './Tooltip'
import { useTranslation } from 'next-i18next'

const OpenExplorerLinkIcon = ({ className }: { className: string }) => {
  const { t } = useTranslation('settings')
  return (
    <Tooltip content={t('open-in-explorer')}>
      <ArrowTopRightOnSquareIcon className={className} />
    </Tooltip>
  )
}

export default OpenExplorerLinkIcon
